import { ParsedUrlQuery } from 'querystring'
import { createFilterOptions } from '@mui/material'
import { Filter, onChangeFunc } from 'components/core/search-filter/filter'
import { getFilterKeyToLabelMap } from 'components/core/task/ContextualTaskSearchFilter'
import { GetEmploymentStatusSearchTermsRequest } from 'pbts/c1/api/user/v1/user'
import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { getEmploymentStatusSearchTermsApi } from 'redux_toolkit/users'

export const EmploymentStatusesQueryParam = 'employmentStatuses'

type EmploymentStatusFilterProps = {
    selected: string[] | undefined
    onChange: onChangeFunc<string>
}

const getOptionSelected = (option1: string, option2: string): boolean => {
    return option1 === option2
}

export const EmploymentStatusFilter = ({ selected, onChange }: EmploymentStatusFilterProps): React.ReactElement => {
    const intl = useIntl()
    const filterOptions = createFilterOptions<string>({})
    const filterKeyToLabel = getFilterKeyToLabelMap(intl)

    const { data, error } = getEmploymentStatusSearchTermsApi.useGetEmploymentStatusSearchTerms(
        GetEmploymentStatusSearchTermsRequest.create({}),
    )

    const renderLabel = useCallback((option: string): string => option, [])

    const filteredTerms = useMemo(() => {
        return data?.terms.filter((term) => term !== '')
    }, [data?.terms])

    // Load initial types from query.
    const fromQuery = useCallback((query: ParsedUrlQuery): string[] => {
        let types = query[EmploymentStatusesQueryParam]
        if (!types) {
            return []
        }

        if (!Array.isArray(types)) {
            types = [types]
        }

        return types
    }, [])

    // Serialize selections to query.
    const toQuery = useCallback((query: ParsedUrlQuery, types: string[]): void => {
        if (types.length !== 0) {
            query[EmploymentStatusesQueryParam] = types
        } else {
            delete query[EmploymentStatusesQueryParam]
        }
    }, [])

    return <Filter<string>
        label={filterKeyToLabel['user-employment-statuses'] || ''}
        options={filteredTerms ?? []}
        selected={selected}
        fromQuery={fromQuery}
        toQuery={toQuery}
        onChange={onChange}
        filterOptions={filterOptions}
        getOptionSelected={getOptionSelected}
        renderLabel={renderLabel}
        error={!!error}
        errorText={error?.message}
    />
}
